<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" size="lg-fix-h" :ariaLabel="$t('app.report_costs_header')">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('app.report_costs_header')}}</h2>
          <base-tooltip-icon :formatContent="true" size="sm" :content="extensionTooltipMessage" placement="bottom" class="ml-2"/>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="vld-parent" style="min-height: 350px">
        <loading 
          :opacity="darkMode ? 0 : 0.5" 
          :background-color="darkMode ? 'var(--darkblue-DEFAULT)' : 'white'" 
          color="var(--primary-DEFAULT)" 
          :active="!isLoadedData" 
          :is-full-page="false" 
          :z-index="100000">
          </loading>
          <div class="p-4 flex flex-col items-center justify-center w-full" style="max-height: 500px">
            <ChartDonut 
              :chardataDonut="chartData"
              :totalTareas="totalTareas"
              :totalHoras="totalHoras"
              class="justify-self-center"
              />
          </div>
      </div>
    </template>
    <template slot="footer">
      <div class="w-full items-start justify-between flex px-4 bg-white py-2 mt-auto dark:bg-darkblue-900">
        <label class="w-full text-sm font-semibold text-secondary-600 dark:text-darkblue-200 block mb-1 mr-1" 
          v-if="isLoadedData">
          {{ labelFechaInicial }}
        </label>
        <label class="w-full text-sm text-end font-semibold text-secondary-600 dark:text-darkblue-200 block mb-1 ml-1" 
          v-if="isLoadedData && lastUpdate"
          style="text-align: end">
          Última actualización: {{ lastUpdate }}
        </label>
      </div>
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from '../base/BaseDialogButton.vue'
import Loading from 'vue-loading-overlay'
import { getInformeCostes } from '@/services/dashboard/getInformeCostes'
import moment from 'moment'
import ChartDonut from '@/components/charts/ChartDonut.vue'
import { i18n } from '@/i18n'

export default
{
  name: 'report-costs-dialog',
  components: {
    BaseDialogButton,
    Loading,
    ChartDonut,
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    dialogOpen: function (value, oldValue) {
      if (value) {
        this.getData()
      } else {
        this.cleanData()
      }
    },
  },
  data: function () {
    return {
      isOpen: this.dialogOpen,
      isLoadedData: false,
      chartData: [],
      totalTareas: 0,
      totalHoras: 0,
      lastUpdate: null,
      initialDate: null,
      colors: [
        'rgb(255, 99, 99)',
        'rgb(255, 185, 99)',
        'rgb(242, 255, 99)',
        'rgb(143, 255, 99)',
        'rgb(99, 255, 221)',
        'rgb(99, 159, 255)',
        'rgb(164, 99, 255)',
        'rgb(255, 99, 229)',
      ]
    }
  },
  mounted: async function () {
  },
  computed: {
    extensionTooltipMessage: function () {
      return i18n.t('tooltip.report_cost_dialog')
    },
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    selectedClientDashboard () {
      return this.$store.getters['dashboard/getSelectedClient']
    },
    isSA: function () {
      return (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador')
    },
    labelFechaInicial () {
      if (!this.chartData || this.chartData.length === 0) return ''
      if (this.initialDate) {
        const fechaMasUnAnyo = moment(this.initialDate).add(1, 'year')
        if (moment().isSameOrAfter(fechaMasUnAnyo)) {
          return 'Informe generado con los datos de los últimos 12 meses'
        }
      } 
      return 'Informe generado con los datos desde: ' + this.initialDate 
    },
  },
  methods: {
    getColor (property) {
      return getComputedStyle(document.querySelector(':root')).getPropertyValue(property)
    },
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
    },
    getParamIdClient () {
      const idClient = this.$store.getters['dashboard/getSelectedClient']
      if (this.isSA && idClient !== 0 && idClient !== null) return this.$store.getters['dashboard/getSelectedClient']
      return null
    },
    cleanData () {
      this.chartData = []
      this.lastUpdate = null
      this.initialDate = null
    },
    formatDate: function (strDate) {
      return moment(strDate).format('DD-MM-yyyy HH:mm')
    },
    getData: async function (data) {
      this.isLoadedData = false
      try {
        const self = this
        this.cleanData()
        const params = { idCliente: this.getParamIdClient() }
        
        const response = await getInformeCostes(params)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          setTimeout(() => {
            this.chartData = response.respuesta
            this.totalTareas = response.Total
            this.totalHoras = response.Horas
            this.chartData.forEach((x, index) => {
              x.color = self.colors[index]
            })
            this.initialDate = this.formatDate(response.FechaInicio)
            if (this.chartData && this.chartData.length > 0 && response.UltimaActualizacion) {
              this.lastUpdate = this.formatDate(response.UltimaActualizacion)
            }
          }, 200)
        }
      } catch (error) {
        console.log(error)
        this.doFeedback()
      } finally {
        this.isLoadedData = true
      }
    },
  }
}
</script>

